export default __webpack_public_path__ + "static/media/Mulish-Bold.3fd0f50b.ttf";